import $ from 'jquery';

const loader = `<div class="editor-sidebar-loader-absolute spinner-grow" role="status">
    <span class="sr-only">Caricamento...</span>
</div>`;

export const sidebarLoader = (targetId) => {
  $(`#${targetId}`).html(loader);
};

// Inject loader into any selector (attachments grid, etc.)
export const sidebarLoaderIn = (selector) => {
  $(selector).html(loader);
};

export const getSidebarLoaderHtml = () => loader;
